<article class="field-group-container row" [class.is-firefox]="isFirefox" [class]="class ?? ''">
  <section class="field-group-name" [class]="groupNameRowClass">
    <div class="group-name">{{ name() }}</div>
    <ng-content select="[group-name-content]"></ng-content>
  </section>
  <section class="field-group">
    <ng-content></ng-content>
  </section>
</article>
